var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "nav-aside",
      class: { "is-active--aside": this.isActiveAside },
    },
    [
      _c(
        "div",
        { staticClass: "nav-aside__block" },
        [
          _c("h3", { staticClass: "nav-aside__label" }, [
            _c(
              "a",
              { staticClass: "nav-aside__a", attrs: { href: "/" } },
              [
                _c("icon-logo-typo", { staticClass: "icon icon--typo" }),
                _vm._v(" "),
                _c("span", { staticClass: "a11y" }, [
                  _vm._v("fastcampus 홈으로"),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "nav-aside__home",
              attrs: { href: "/", title: "홈으로" },
            },
            [_c("icon-home", { staticClass: "icon icon--home" })],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "nav-aside__close",
              attrs: { type: "button" },
              on: { click: _vm.toggleHolder },
            },
            [_c("icon-close", { staticClass: "icon icon--close" })],
            1
          ),
          _vm._v(" "),
          _c("icon-logo-symbol", { staticClass: "icon icon--circle" }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }